import { Component, Input } from '@angular/core';
import { faArrowRight, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { environment } from '@rensa/environments/environment';
import { DatePipe } from '@angular/common';
import { ButtonType } from '@rensa/shared/enums/button-type.enum';
import { ItemType } from '@rensa/shared/enums/item-type.enum';

export enum ContactStyle {
    HOME,
    DETAIL
}

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent {
    @Input() showContact = true;
    @Input() showAllEventsButton = false;
    @Input() contactStyle = ContactStyle.HOME;
    @Input() showInviteColleague = false;
    @Input() itemId: string;
    @Input() valueMap: Map<string, number | string> = new Map<string, number | string>();
    itemTypeEnum = ItemType;
    itemType: ItemType;
    ButtonType = ButtonType;
    faEnvelope = faEnvelope;
    faArrowRight = faArrowRight;
    contactEmail = environment.contactEmail;

    constructor(private router: Router, private datePipe: DatePipe) {
        this.itemType = environment.itemType;
    }

    getContactStyle(): string {
        return this.contactStyle === ContactStyle.HOME ? 'contact' : 'contact-style-detail';
    }

    openMail(): void {
        window.location.href = `mailto:${environment.contactEmail}`;
    }

    shareWithColleague(): void {
        const dateVal: number = this.valueMap.get('date') as number;
        const dateObj = new Date(dateVal * 1000);
        const formattedDateString = this.datePipe.transform(dateObj, 'EEEE dd MMMM yyyy', 'nl-NL');
        const subject = environment.sendToEmail[environment.itemType].subject;
        const body = environment.sendToEmail[environment.itemType].itemDetail.body
            .replace('{{location}}', this.valueMap.get('location').toString())
            .replace('{{title}}', this.valueMap.get('title').toString())
            .replace('{{date}}', formattedDateString)
            .replace('{{link}}', `${environment.frontendUrl}/${this.itemId}/${this.valueMap.get('eventId').toString()}`);
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }
}
